import { ShouldTrackMutationPredicates } from './subscriptionsMutationsMap.types'

export const getShouldTrackMutationPredicates: ShouldTrackMutationPredicates = {
  deleteSharePermanently: true,
  emptyWorkspaceTrash: true,
  shareDelete: true,
  restoreShare: true,
  deleteProject: true,
  deleteProjectPermanently: true,
  restoreProject: true,
  addProjectMember: true,
  removeProjectMember: true,
  createAnnotation: true,
  createAnnotationComment: true,
  moveAnnotation: true,
  editComment: true,
  resolveAnnotation: true,
  unResolveAnnotation: true,
  archiveProject: true,
  unarchiveProject: true,
  updateVersionDescription: true,
  versionUpdateKind: true,
}
